import React, { FC } from 'react';
import styled from 'styled-components';
import { IIconButtonList } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import { Column, Columns } from '../base/grid';
import RichTextTitle from '../base/richTextTitle';
import IconButtonWithText from '../iconButtonWithText';

const Root = styled.div`
	margin-top: 150px;
`;

const ColumnsStyled = styled(Columns)`
	justify-content: center;
	margin-block: 64px -3rem;
`;

const ColumnStyled = styled(Column)`
	display: flex;
	margin-bottom: 3rem;
`;

const IconButtonWithTextStyled = styled(IconButtonWithText)`
	width: 100%;
`;

interface Props {
	content: IIconButtonList;
}

const IconButtonList: FC<Props> = ({ content }) => {
	return (
		<Root>
			<ContentContainer>
				{!content.Values.HideTitle && <RichTextTitle content={content.Values.Title} type="h3" />}
				<ColumnsStyled>
					{content.Values.IconButtons.map((iconButton, idx) => (
						<ColumnStyled
							key={idx}
							tablet={1 / 2}
							desktopSmall={content.Values.IconButtons.length > 2 ? 1 / 3 : 1 / 2}>
							<IconButtonWithTextStyled
								title={iconButton.Values.Button.Name}
								href={iconButton.Values.Button.Url}
								target={iconButton.Values.Button.Target}
								iconUrl={iconButton.Values.Icon.Src}
							/>
						</ColumnStyled>
					))}
				</ColumnsStyled>
			</ContentContainer>
		</Root>
	);
};

export default IconButtonList;
